import isDev from './isDev';
import hasOwnProperty from './hasOwnProperty';

function missingStateWarning(_ref) {
  var items = _ref.items,
      props = _ref.props,
      cb = _ref.cb;
  if (!isDev) return;
  props.forEach(function (prop) {
    if (!hasOwnProperty(items, prop)) {
      cb(prop);
    }
  });
}

export default missingStateWarning;